import { Panel } from 'rsuite'
import useTranslation from '@/hooks/useTranslation'
import styles from './vehicleSelector.module.scss'

const VehicleSelectorTextModel = ({ modelAlias, year, onClickModel }) => {
  const t = useTranslation()

  return (
    <Panel
      bordered
      className={styles.vehicleSelectorModel}
      style={{ marginRight: 0 }}
      onClick={onClickModel}
      tabIndex={0}
      role="button"
      aria-label={t('select_vehicle_button_description', 'Select {{year}} {{model}} to view vehicle resources', {
        year,
        model: modelAlias
      })}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClickModel()
        }
      }}
    >
      {modelAlias}
    </Panel>
  )
}

export default VehicleSelectorTextModel
